































import Vue from 'vue';
import { LOAD_STATE } from '@/store/shared';
import CampaignGlance from '@/components/Reactivation/Analytics/ReactivationCampaignGlance.vue';
import ReactivationOverall from '@/components/Reactivation/Analytics/ReactivationOverall.vue';
// import ReactivationBreakdown from '@/components/Reactivation/Analytics/ReactivationBreakdown.vue';
// import ReactivationEmailRates from '@/components/Reactivation/Analytics/ReactivationEmailRates.vue';
// import ReactivationRecovered from '@/components/Reactivation/Analytics/ReactivationRecovered.vue';
// import ReactivationTimeline from '@/components/Reactivation/Analytics/ReactivationTimeline.vue';
import ReactivationActivity from '@/components/Reactivation/Analytics/ReactivationActivity.vue';

export default Vue.extend({
  name: 'ReactivationAnalytics',
  components: {
    CampaignGlance,
    // ReactivationBreakdown,
    // ReactivationEmailRates,
    ReactivationOverall,
    // ReactivationRecovered,
    // ReactivationTimeline,
    ReactivationActivity,
  },
  data() {
    return {
      LOAD_STATE,
    };
  },
});
